<template>
  <div>Loading...</div>
</template>
<script>
import BrandingMixin from '@src/mixins/branding'
export default {
  name: 'HomePage',
  mixins: [BrandingMixin],
  created() {
    this.$router.replace(this.guestUserLandingPageRoute)
  },
}
</script>
